import { render, staticRenderFns } from "./FormCustomer.vue?vue&type=template&id=e4ef7b3a"
import script from "./FormCustomer.vue?vue&type=script&lang=js"
export * from "./FormCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports